<template>
  <BaseModal
    :value="true"
    :modal-title="$t('utils.notificationHistory')"
    @close="$emit('close')"
  >
    <template #modal>
      <BaseDataTable
        :headers="headers"
        class="elevation-1 ma-6"
        :items="folderReminds"
        :items-per-page="15"
        :loading="loading"
        :loading-text="$t('utils.loadingData')"
      >
        <template #item="{ item }">
          <tr>
            <td>
              <div class="d-flex flex-column align-start py-3">
                <BaseParagraph
                  text="secondary"
                  class="mb-1"
                  v-text="
                    `${$d(new Date(item.dateCreated), 'detailed')} (${
                      item.collaborator.email
                    })`
                  "
                />
              </div>
            </td>
            <td>
              <div class="d-flex flex-column align-start py-3">
                <BaseMarkdownViewer
                  v-if="item.transactionalEmail"
                  :content="item.transactionalEmail.emailContent"
                  class="notification_text"
                />
              </div>
            </td>
          </tr>
        </template>
      </BaseDataTable>
    </template>
    <template #actions>
      <BaseButton text class="ml-auto" color="#707080" @click="$emit('close')">
        {{ $t("navigation.close") }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import { getFolderRemind } from "@/modules/Folder/Services/folder.service";
import BaseMarkdownViewer from "@/core/Components/UI/Markdown/BaseMarkdownViewer.vue";

export default {
  name: "FolderNotificationHistoryDialog",
  components: { BaseMarkdownViewer },
  props: {
    organizationId: {
      type: [Number, String],
      required: true,
    },
    folderId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      folderReminds: [],
      loading: false,
      headers: [
        {
          text: this.$t("utils.notificationDate"),
          align: "start",
          value: "dateCreated",
        },
        {
          text: this.$t("utils.notificationContent"),
          align: "start",
          value: "emailContent",
        },
      ],
    };
  },
  created() {
    this.fetchFolderReminds();
  },
  methods: {
    async fetchFolderReminds() {
      this.loading = true;
      try {
        this.folderReminds = await getFolderRemind(
          this.organizationId,
          this.folderId
        );
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.notification_text {
  font-size: 14px;
}
</style>
